import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";
import { EstRetiroMatDir, BusquedaEstIndDir } from "../../funciones/EstudiantesFunction";

import EstudiantesRetiroTable from "./EstudiantesRetiroTable";

class RetiroMaterias extends Component {
    state = {
        strings: "",
        icon2: "",
        estudiantes: [],
        preload: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando Solicitudes de Retiro de Materias"
        },
        cantEst: <i className="fa fa-spinner fa-spin"></i>,
        cantEstB: 0,
        estudianteB: [],
        preloadB: {
            icon: "",
            text: "Ingresa la C.I., nombre o apellido del estudiante"
        },
    }

    componentDidMount = () => {
        this.busquedaEstudiante()
    }

    busquedaEstudiante = () => {
        EstRetiroMatDir((resp) => {
            let preloadIcon = "";
            let preloadText = "";

            if (resp.length === 0) {
                preloadIcon = "fa fa-times";
                preloadText = "No tienes solicitudes de retiro de materias"
            }

            this.setState({
                estudiantes: resp,
                cantEst: resp.length,
                preload: {
                    icon: preloadIcon,
                    text: preloadText
                }
            })
        })
    }

    busquedaEst = () => (e) => {
        if (e.which === 13){
            if (this.state.strings === "") return null;

            this.setState ({
                preloadB:{
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando estudiantes, espera"
                },
                estudianteB: []
            }, () => {
                BusquedaEstIndDir (this.state.strings, (resp) => {console.log(resp);
                    let prel = { icon: "", text: "" };
                    if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };

                    this.setState({
                        cantEstB: resp.length,
                        estudianteB: resp,
                        preloadB: prel
                    })

                })
            })
        }
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En este módulo puedes procesar la solicitud de retiro de materias de los estudiates que asi lo requieran o rechazar dicha solicitud
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                También puedes buscar por cédula, nombre o apellido a algún estudiante para retirar una o mas asignaturas.
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong className="text-primary">Procesar Retiro de Materias:</strong> para realizar este proceso simplemente haz click en el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
            </Col>
            <Col md={4} align="justify" className="custom-mt-10 text-primary" style={{fontSize: 10}}>
                Confirmar Retiro
            </Col>
            <Col md={8} align="justify" className="custom-mt-10">
                Esta opción permite aprobar o rechazar la solicitud de retiro de materia del estudiante.
            </Col>
            <Col md={4} align="justify" className="custom-mt-10 text-warning" style={{fontSize: 10}}>
                Retirar Materias
            </Col>
            <Col md={8} align="justify" className="custom-mt-10">
                Esta opción permite mostrar las materias inscritas para su retiro.
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong>Importente: En caso de aprobar el retiro, la materia no queda eliminada en su totalidad sino que pasa a adminsitración para revisar su estado de cuenta</strong>
            </Col>
        </Row>
    )

    listRetiroMat = () => {
        let {estudiantes, preload} = this.state;

        if (estudiantes.length === 0) return (
            <tr>
                <td colSpan={3} align="center"><i className={preload.icon}></i> {preload.text}</td>
            </tr>
        )

        return (
            estudiantes.map(option => (
                <EstudiantesRetiroTable
                tipo = "Solicitud"
                key={option.id}
                data={option}
                update = {()=> {this.busquedaEstudiante()}}
                />
            ))
        )
    }

    listRetiroMatBusq = () => {
        let {estudianteB, preloadB} = this.state;

        if (estudianteB.length === 0) return (
            <tr>
                <td colSpan={3} align="center"><i className={preloadB.icon}></i> {preloadB.text}</td>
            </tr>
        )

        return(
            estudianteB.map(option => (
                <EstudiantesRetiroTable
                tipo = "Busqueda"
                key={option.id}
                data={option}
                update = {()=> {this.busquedaEstudiante()}}
                />
            ))
        )
    }

    render() {
        let {strings, icon2, cantEst, cantEstB} = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-info">
                            Búsqueda de Estudiantes <i className={icon2}></i>
                            <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={strings} onChange={this.cambiaValor("strings")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </div>
                        <div className="custom-mt-10 text-danger">Resultado de la Búsqueda ({cantEstB})</div>
                        <div className="custom-alert-info" style={{padding: 5}}>
                            <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: "40vh"}}>
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td width="60%" style={styles}><strong>Estudiantes</strong></td>
                                            <td width="30%" align="center" style={styles}><strong>Carrera</strong></td>
                                            <td width="10%" align="center" style={styles}><strong>Acciones</strong></td>
                                        </tr>
                                        {this.listRetiroMatBusq()}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                        <div className="custom-mt-10 text-danger">Estudiantes con solicitudes pendientes ({cantEst})</div>
                        <div className="custom-alert-warning" style={{padding: 5}}>
                            <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: "40vh"}}>
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color-warning">
                                            <td width="60%" style={styles}><strong>Estudiantes</strong></td>
                                            <td width="30%" align="center" style={styles}><strong>Carrera</strong></td>
                                            <td width="10%" align="center" style={styles}><strong>Acciones</strong></td>
                                        </tr>
                                        {this.listRetiroMat()}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Retiro de Materias</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default RetiroMaterias;


// WEBPACK FOOTER //
// ./src/views/Registros/RetiroMaterias.jsx